module.exports = __webpack_public_path__ + "img/ihk.ac04d135.png";